import React from 'react'
import { graphql } from 'gatsby'
import { Billboard, LgWrapper, H1, Link, Button } from '@raysync/common/components'
import { Navigation } from '@raysync/common/services'
import Layout from '../../components/layout'
import { Banner, Title, Section, DocumentList, DoucmentItem, VideoList, VideoItem, PlayIcon } from './index.atom'
import { useMedia } from '@raysync/common/hooks'
import DocumentCard from './cards'
import Card1 from './images/card6.png'
import Card2 from './images/card5.png'
import Card3 from './images/card4.png'
import Icon1 from '@raysync/common/components/svg/document/doc1'
import Icon2 from '@raysync/common/components/svg/document/doc2'
import Icon3 from '@raysync/common/components/svg/document/doc3'
import Bg1 from './images/bg1.png'
import Bg2 from './images/bg2.png'
import Bg3 from './images/bg3.png'
import { useDocumentsQuery } from '../../service/index'
import { SearchInput } from './search-input'
const cardList = [
  {
    text: '《镭速传输产品介绍精简版》',
    img: Card1,
    pdfName: '镭速传输%C2%A0产品介绍%C2%A0精简版%20v3.0.pdf',
  },
  {
    text: '《镭速传输协议技术白皮书》',
    img: Card2,
    pdfName: '镭速 传输协议技术白皮书.pdf',
  },
  {
    text: '《镭速产品安全技术白皮书》',
    img: Card3,
    pdfName: '镭速 产品安全技术白皮书.pdf',
  },
]

const videoList = [
  {
    img: Bg1,
    title: '产品介绍',
    url: '/support/document/video/raysync',
  },
  {
    img: Bg2,
    title: '部署指南',
    url: '/support/document/video/deployment-video',
  },
  {
    img: Bg3,
    title: '功能指南',
    url: '/support/document/video/synctask-video',
  },
]
const DocumentPage = props => {
  const { location, data } = props
  const isMobile = useMedia()
  useDocumentsQuery()
  const documentList = [
    {
      img: <Icon1 />,
      title: '快速入门',
      desc: [
        {
          text: '服务器部署',
          url: '/support/document/product/start-deployment/',
        },
        {
          text: 'License激活',
          url: '/support/document/product/License/',
        },
        {
          text: '创建用户',
          url: '/support/document/product/create-users/',
        },
        {
          text: '存储配置',
          url: '/support/document/product/storage/',
        },
        {
          text: '创建高速传输任务',
          url: '/support/document/product/create-task/',
        },
      ],
      url: '/support/document/product/storage/',
    },
    {
      img: <Icon2 />,
      title: '管理端操作指南',
      desc: [
        {
          text: '用户',
          url: '/support/document/product/local-user',
        },
        {
          text: '空间管理',
          url: '/support/document/product/space/',
        },
        {
          text: '配置',
          url: '/support/document/product/settings/',
        },
        {
          text: '安全',
          url: '/support/document/product/security/',
        },
        {
          text: '通知',
          url: '/support/document/product/notification/',
        },
      ],
      url: '/support/document/product/server-info/',
    },
    {
      img: <Icon3 />,
      title: '用户操作指南',
      desc: [
        {
          text: '我的文件',
          url: '/support/document/product/files/',
        },
        {
          text: '群组文件库',
          url: '/support/document/product/group/',
        },
        {
          text: '客户端设置',
          url: '/support/document/product/client/',
        },
        {
          text: '同步传输',
          url: '/support/document/product/sync-task/',
        },
        {
          text: '点对点传输',
          url: '/support/document/product/p2p/',
        },
      ],
      url: '/support/document/product/profile/',
    },
  ]
  return (
    <Layout pageType='support' location={location}>
      <Banner>
        <LgWrapper>
          <H1>帮助中心</H1>
          <p>
            帮助中心提供镭速所有产品的相关使用说明文档，方便您快速解决问题。如您找不到所需内容，请联系您的专属客户经理或我们的技术支持团队。
          </p>
          <SearchInput />
        </LgWrapper>
        <Billboard fluid={isMobile ? data.mBanner.childImageSharp.fluid : data.banner.childImageSharp.fluid} />
      </Banner>
      <Section>
        <LgWrapper>
          <Title>帮助文档</Title>
          <DocumentList>
            {documentList.map((item, index) => (
              <DoucmentItem key={index}>
                <div>
                  {item.img}
                  <div>
                    <h3>{item.title}</h3>
                    <ul>
                      {item.desc.map((i, j) => (
                        <li
                          key={j}
                          onClick={() => {
                            Navigation.to({
                              link: i.url,
                            })
                          }}
                        >
                          • {i.text}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Link to={item.url}>查看全部&gt;</Link>
              </DoucmentItem>
            ))}
          </DocumentList>
        </LgWrapper>
      </Section>
      <Section hasBg>
        <LgWrapper>
          <Title>演示视频</Title>
          <VideoList>
            {videoList.map((item, index) => (
              <VideoItem key={index} bg={item.img}>
                <div>
                  <h3>{item.title}</h3>
                  <PlayIcon
                    onClick={() => {
                      Navigation.to({
                        link: item.url,
                      })
                    }}
                  >
                    <span />
                  </PlayIcon>
                </div>
              </VideoItem>
            ))}
          </VideoList>
          <Button
            className='center'
            size='large'
            onClick={() => {
              Navigation.to({
                link: '/support/document/video/raysync',
              })
            }}
          >
            了解更多
          </Button>
        </LgWrapper>
      </Section>
      <Section>
        <LgWrapper>
          <Title>白皮书</Title>
          <DocumentCard cards={cardList} hasMore />
        </LgWrapper>
      </Section>
    </Layout>
  )
}
export default DocumentPage
export const query = graphql`
  query {
    banner: file(relativePath: { eq: "banner.png" }) {
      ...fluidImage
    }
    mBanner: file(relativePath: { eq: "banner_m.png" }) {
      ...fluidImage
    }
  }
`
